export default __webpack_public_path__ + "static/media/plan.5edf2061.svg";